import template from './condition-rating-type.jade';
import conditionRatingTypeOptions from '../../../enums/condition-rating-type';

export default angular
    .module('cian.addForm.buildingConditionRatingType', [])
    .directive('cianAfAboutBuildingConditionRatingType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = conditionRatingTypeOptions;
        },
        controllerAs: 'conditionRatingType',
        template,
    }))
    .name;
